if (!window.Eurus.loadedScript.has('product-recommendations.js')) {
  window.Eurus.loadedScript.add('product-recommendations.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.store('xProductRecommendations', {
        loading: false,
        listOfUpsellProducts: [],
        el: '',
        listUpsellId: [],
        productCount: 0,
        async loadUpsell(el, url, listId, limit, maxItems) {
          this.el = el;
          this.loading = true;
          this.listOfUpsellProducts = [];
          this.productCount = 0;
          this.listUpsellId = [];         
          // Geo: the cart upsell shows ONLY Search & Discovery "Complete Your Setup" (complementary) items.
          // No related fallback: if none are left to show, hide the whole block.
          const geoUsedComplementary = await this.geoLoadComplementary(el, url, listId, limit, maxItems);
          if (!geoUsedComplementary) this.geoHideUpsell(el);
          this.loading = false;
          return;
          for (let i = 0; i < listId.length; i++) {
            if (this.productCount >= maxItems) {
              break;
            }    
            try {
              const response = await fetch(`${url}&product_id=${listId[i]}&limit=${limit}&intent=related`);
              const text = await response.text();
              const html = document.createElement('div');
              html.innerHTML = text;
              const des = document.querySelector('.cart-upsell-carousel');
              const src = html.querySelector('.cart-upsell-carousel')
              if(src && des) des.innerHTML = src.innerHTML
              const recommendations = html.querySelector('.product-recommendations');
      
              if (recommendations && recommendations.innerHTML.trim().length) {
                const newUpsellProducts = recommendations.querySelectorAll('template[x-teleport="#cart-upsell-drawer"], template[x-teleport="#cart-upsell"]');
                this.listOfUpsellProducts = [...newUpsellProducts, ...this.listOfUpsellProducts];
      
                for (let index = 0; index < this.listOfUpsellProducts.length; index++) {
                  if (this.productCount >= maxItems) {
                    break;
                  }
                  
                  const element = this.listOfUpsellProducts[index];
                  const elementId = new DOMParser().parseFromString(element.innerHTML, 'text/html').querySelector('.hover-text-link, .link-product-variant').id;
                  
                  if (!this.listUpsellId.includes(elementId)) {
                    this.listUpsellId.push(elementId);
                    el.appendChild(element);
                    this.productCount++;
                  }
                }
      
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0';
                }
              } else if (recommendations && recommendations.classList.contains('main-product')) {
                recommendations.classList.add("hidden");
                el.innerHTML = recommendations.innerHTML;
              }
            } catch (e) {
              console.error(e);
            } finally {
              this.loading = false;
            }
          }
        },
        geoHideUpsell(el) {
          const wrap = el.closest('#mini-cart-upsell, #main-cart-upsell');
          if (wrap && wrap.id === 'mini-cart-upsell') {
            const mobileFooter = wrap.closest('.footer-cart-drawer-mobile');
            wrap.style.display = 'none';
            wrap.setAttribute('aria-hidden', 'true');
            if (mobileFooter && !mobileFooter.querySelector('.cart-drawer-footer')) mobileFooter.style.display = 'none';
          } else if (wrap) {
            wrap.style.display = 'none';
          }
          try {
            const scope = window.Alpine && Alpine.$data(el);
            if (scope && 'show' in scope) scope.show = false;
          } catch (e) {}
        },
        async geoLoadComplementary(el, url, listId, limit, maxItems) {
          const found = [];
          const ids = [];
          let carousel = null;
          for (let i = 0; i < listId.length && found.length < maxItems; i++) {
            try {
              const response = await fetch(`${url}&product_id=${listId[i]}&limit=${limit}&intent=complementary`);
              const html = document.createElement('div');
              html.innerHTML = await response.text();
              const recommendations = html.querySelector('.product-recommendations');
              if (!recommendations || !recommendations.innerHTML.trim().length) continue;
              const templates = recommendations.querySelectorAll('template[x-teleport="#cart-upsell-drawer"], template[x-teleport="#cart-upsell"]');
              for (const element of templates) {
                if (found.length >= maxItems) break;
                const link = new DOMParser().parseFromString(element.innerHTML, 'text/html').querySelector('.hover-text-link, .link-product-variant');
                const elementId = link ? link.id : '';
                if (elementId && ids.includes(elementId)) continue;
                ids.push(elementId);
                found.push(element);
              }
              if (found.length && !carousel) carousel = html.querySelector('.cart-upsell-carousel');
            } catch (e) {
              console.error(e);
            }
          }
          if (!found.length) return false;
          const des = document.querySelector('.cart-upsell-carousel');
          if (carousel && des) des.innerHTML = carousel.innerHTML;
          this.listOfUpsellProducts = found;
          this.listUpsellId = ids;
          this.productCount = found.length;
          found.forEach((element) => el.appendChild(element));
          return true;
        },
        load(el, url) {
          this.loading = true;
          fetch(url)
            .then(response => response.text())
            .then(text => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('.product-recommendations');
              if (recommendations && recommendations.innerHTML.trim().length) {
                requestAnimationFrame(() => {
                  el.innerHTML = recommendations.innerHTML;
                });
                if (recommendations.classList.contains('main-product')) {
                  el.className += ' mb-4 md:mb-6 border-y border-solid accordion empty:border-b-0';
                }
              } else if (recommendations.classList.contains('main-product')) {
                requestAnimationFrame(() => {
                  setTimeout(() => {
                    recommendations.classList.add("hidden");
                    el.innerHTML = recommendations.innerHTML;
                  }, 0)
                });
              }
            })
            .catch(e => {
              console.error(e);
            });
        }
      })     
    });
  });
}